export type RemoveFromLookupTableArgs = {
  id: string;
  byId: Record<string, unknown>;
};

export type RemoveFromLookupTableReturn = {
  newById: Record<string, unknown>;
  newAllIDs: string[];
};

export const removeFromLookupTable = ({
  id,
  byId,
}: RemoveFromLookupTableArgs): RemoveFromLookupTableReturn => {
  const { [id]: idToRemove, ...newById } = byId;

  return {
    newAllIDs: Object.keys(newById),
    newById,
  };
};
